import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.avatars.index-page', () => {
  import('./internal/avatars__index-page').then(({ default: Component }) => Component());
});
